import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";

export const AppInputBelowDropDown = memo(({ optionList, optionKey, optionValue, onSelect, selected, width, disabled, error }) => {
    const [open, setOpen] = useState(false);
    const refDropdownContainer = useRef();
    const uniqueKey = useMemo(() => Math.floor(Math.random() * 999));

    const handleMouseDown = useCallback((event) => {
        if (refDropdownContainer.current && !refDropdownContainer.current.contains(event.target)) {
            setOpen(false)
        }
    });

    useEffect(() => {
        if (open) {
            window.addEventListener("mousedown", handleMouseDown);
        } else {
            window.removeEventListener("mousedown", handleMouseDown);
        }
        return () => window.removeEventListener("mousedown", handleMouseDown);
    }, [open])

    const handleOnSelect = (item) => {
        onSelect(item[optionKey]);
        setOpen(false);
    }

    return (
        <div ref={refDropdownContainer} className="position-relative mb-2" style={{ height: "20px", width: width || "100%" }}>
            <div className="d-flex align-items-center justify-content-between px-1" onClick={() => !Boolean(disabled) && setOpen((prev) => !prev)}>
                <div
                    style={{
                        color: error ? '#FF0000' : '#A5A5A5',
                        fontSize: "clamp(12px, 0.729vw, 1.5vw)",
                        lineHeight: "17px"
                    }}
                >
                    {selected}
                </div>
                <div style={{ cursor: "pointer" }}>
                    {open ? <BsChevronUp color="#333333" size={10} /> : <BsChevronDown color="#333333" size={10} />}
                </div>
            </div>
            {open &&
                <div
                    className="position-absolute d-flex flex-column w-100 py-1 gap-1"
                    style={{
                        backgroundColor: "#FFFFFF",
                        boxShadow: "0px 3px 12px #3B45581A",
                        zIndex: 1
                    }}
                >
                    {optionList?.map((item, index) => (
                        <div
                            key={`dropdown-item-${uniqueKey}-${index}`}
                            onClick={() => handleOnSelect(item)}
                            style={{
                                color: "#333333",
                                fontSize: "12px",
                                lineHeight: "17px",
                                backgroundColor: (selected && item[optionKey] === selected) ? "#F1F1F1" : "transparent",
                                padding: "5px",
                                cursor: "pointer"
                            }}
                        >
                            {item[optionValue]}
                        </div>
                    ))}
                </div>
            }
        </div>
    )
})